import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-trp-content',
  imports: [],
  templateUrl: './trp-content.component.html',
  styleUrls: ['./trp-content.component.scss'],
})
export class TrpContentComponent {
  @Input() user: any;
}
